import graphql__4c4d528ecb0d5db29565 from "./__generated__/UserManagementHeader_userInfo.graphql.ts";import { Heading } from '@portal/components'
import graphql from 'babel-plugin-relay/macro'
import { Container } from 'components/layout'
import { useFragment } from 'react-relay/hooks'

import { UserManagementHeader_userInfo$key } from './__generated__/UserManagementHeader_userInfo.graphql'

const userInfoFragment = graphql__4c4d528ecb0d5db29565

type Props = {
  user: UserManagementHeader_userInfo$key
}

export default function UserManagementHeader({ user }: Props) {
  const data = useFragment(userInfoFragment, user)

  return (
    <div className="h-24 bg-background">
      <Container className="flex h-full flex-col justify-center py-4">
        <Heading level={1} data-testid="userTenantHeader">
          {data.firstName} {data.lastName}
        </Heading>
      </Container>
    </div>
  )
}
